import { Configuration } from 'src/app/configuration';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/service/auth/auth.service';
import { Router } from '@angular/router';
import { ApplicantService } from 'src/app/service/applicant.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { IApplicant } from 'src/app/model/IApplicant';
import { CookiesLocalService } from 'src/app/service/cookies-local.service';
import { BehaviorModelChangeService } from 'src/app/service/behavior-model-change.service.service';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})



export class LoginComponent  implements OnInit {
  // btn-loading


  get loginFormControls() { return this.loginForm.controls; }

  constructor(private fb: FormBuilder,private utilService: UtilService, private authService: AuthService,
              private applicantService: ApplicantService, private router: Router
    ,         private toastr: ToastrService, private cookieService: CookieService
    ,         private cookieLocal: CookiesLocalService, private behaviorModelChangeService: BehaviorModelChangeService) {

    this.showLoadingIndicator = false;
    }

 public loginForm: FormGroup;
  submitted = false;
  isLoggedIn: boolean;
  globelReponse: any;
  showLoadingIndicator: boolean;
  errrorMessage: any;
  message: string;

  public applicant: IApplicant;

  ngOnInit() {

    this.loginForm = this.fb.group({
      id: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],

    });

  }

  onSubmit() {


    this.showLoadingIndicator = true;

    const user = this.loginForm.value;
    user.username = this.loginForm.value.id;
    this.submitted = true;
    this.isLoggedIn = false;
    this.authService.removeToken();


    this.authService.ValidateUser(user).subscribe((result) => {
      // console.log(result);

      this.globelReponse = result;
      this.getApplicantData(user.id);

  }, error => {
    const loginErrorMessage = error.body.error_description;
    this.toastr.error(loginErrorMessage, 'Login Failed');
    this.showLoadingIndicator = false;

  });

    return;

  }


  private getApplicantData(id) {
    this.applicantService.getApplicant(id)
      .subscribe(data => {
        this.applicant = data;

        this.utilService.getSystemConfig().subscribe(config => {



          if (data.AdmittedProgrammeId) {

            if(data.AdmittedHallId && config.ShowAdmissionPrintOut){
                this.behaviorModelChangeService.onUserPictureChanged(data.PhotoUrl);
                this.cookieLocal.getRefreshedApplicantData(data);
                this.router.navigate(['/admission-list/congrats']);

            }else{
                this.toastr.success('Admission Letter not ready for printing', 'Thank You');
                this.showLoadingIndicator = false;
            }



            } else if (!data.IsAdmissionOngoing) {
              this.message = data.ApplicationType;
              this.showLoadingIndicator = false;
            }
            else {
              this.behaviorModelChangeService.onUserPictureChanged(data.PhotoUrl);
              this.cookieLocal.getRefreshedApplicantData(data);
              this.getApplicationGuardian(data.GuardianId, id);
              this.applicantService.getApplicantCampusChoice(data.ApplicationId).subscribe(data =>
                {
                  if(data){
                    localStorage.setItem(Configuration.localStorageData.campusId,data.CampusId);

                  }
                });


              }




        });





      }, error => {
        this.errrorMessage = error;
        this.showLoadingIndicator = false;
        console.log(error);
      });
  }
  getApplicationGuardian(guardianId: number, userId) {

    this.applicantService.getApplicationGuardianData(guardianId).subscribe(data => {

      this.cookieLocal.getRefreshedGuardianData(data);

      this.getUserData(userId);

    }, error => {

      this.showLoadingIndicator = false;

    });

  }

  getUserData(studentId) {
    this.authService.getUserData(studentId)
    .subscribe(data => {
      this.cookieLocal.getRefreshedLoginUserData(data);
      this.router.navigate(['/applicant/dashboard']);

   }, error => {console.log(error);

                this.showLoadingIndicator = false;

  });
  }




}
